import { Link } from "react-router-dom";
import { useState } from "react";
import { cn } from "@/lib/cn";

type LogoProps = {
  className?: string;
  compact?: boolean;
};

export function Logo({ className, compact = false }: LogoProps) {
  const [failed, setFailed] = useState(false);

  return (
    <Link
      to="/"
      className={cn(
        "inline-flex items-center gap-2.5 font-display text-lg font-bold tracking-tight text-fg",
        className,
      )}
      aria-label="ServiTrex home"
    >
      {failed ? (
        <span
          aria-hidden
          className="grid h-9 w-9 place-items-center rounded-xl bg-ink text-sm font-extrabold text-teal"
        >
          ST
        </span>
      ) : (
        <img
          src="/brand/servitrex-logo.svg"
          alt=""
          width={36}
          height={36}
          className="h-9 w-9 rounded-xl shadow-soft"
          onError={() => setFailed(true)}
        />
      )}
      {!compact && (
        <span className="leading-none">
          Servi<span className="text-teal-deep">Trex</span>
        </span>
      )}
    </Link>
  );
}
